import { ButtonVariant } from '../../sections/Commons';
import { DefaultElementStyles } from '../../sections/Commons/styles/styles';

export const ButtonVariantStyles = {
  [ButtonVariant.PRIMARY]: {
    borderColor: '#000',
    backgroundColor: '#000',
    color: '#fff',
    textAlign: 'center',
    // borderRadius: '0',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#000',
      borderColor: '#fff',
    },
    ...DefaultElementStyles.ButtonDefaultStyles,
  },
  [ButtonVariant.SECONDARY]: {
    color: '#000',
    borderColor: '#000',
    backgroundColor: 'transparent',
    textAlign: 'center',
    // borderRadius: '0',
    '&:hover': {
      borderColor: '#000',
      backgroundColor: '#fff',
      // borderRadius: '0',
    },
    ...DefaultElementStyles.ButtonDefaultStyles,
  },
  [ButtonVariant.TERTIARY]: {
    color: '#000',
    borderColor: '#000',
    backgroundColor: 'transparent',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#000',
      color: '#fff',
      borderColor: '#000',
    },
    ...DefaultElementStyles.ButtonDefaultStyles,
    border: 'none',
  },
};
